import { Base, ShieldCrossIcon } from '@itsrever/design-system'
import { useAuthorizationStatus } from '@/hooks'
import { useTranslation } from 'react-i18next'

interface UnauthorizedStatusBannerProps {
  processId: string
}

const UnauthorizedStatusBanner: React.FC<UnauthorizedStatusBannerProps> = ({
  processId
}) => {
  const { t } = useTranslation()
  const { authorizationStatus } = useAuthorizationStatus(processId)
  const user = authorizationStatus?.unauthorization_details?.user ?? ''
  const reason = authorizationStatus?.unauthorization_details?.reason ?? ''
  return (
    <Base.Callout tone="warning" icon={<ShieldCrossIcon />} className="mb-5">
      <p className="font-medium text-neutral-900">
        {t('process_details_page.process_unauthorized')}
      </p>
      <p className="text-neutral-600">
        {t('process_details_page.unauthorized_banner_description')}
      </p>
      <dl className="mt-3 flex flex-col gap-2">
        <div>
          <dt className="text-xs text-neutral-500">
            {t('process_details_page.unauthorized_banner_user')}
          </dt>
          <dd className="font-medium text-neutral-900">{user}</dd>
        </div>
        <div>
          <dt className="text-xs text-neutral-500">
            {t('process_details_page.unauthorized_banner_reason')}
          </dt>
          <dd className="text-neutral-900">{reason}</dd>
        </div>
      </dl>
    </Base.Callout>
  )
}
export default UnauthorizedStatusBanner
